import { render, staticRenderFns } from "./Issuu.vue?vue&type=template&id=7f755c68&scoped=true&"
import script from "./Issuu.vue?vue&type=script&lang=js&"
export * from "./Issuu.vue?vue&type=script&lang=js&"
import style0 from "./Issuu.vue?vue&type=style&index=0&id=7f755c68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f755c68",
  null
  
)

export default component.exports